var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.token?.address)?_c('i',{staticClass:"bi-star-fill !text-lg cursor-pointer px-1",class:{
		'text-secondary': !_setup.isFavorite,
		'text-warn': _setup.isFavorite,
	},on:{"click":_setup.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }